///
/// !!! 아래에 현재 프로바이더 관련 메세지 뿐아니라 앱 UI에 관련된 메세지도 포함되어있음
/// 수정필요
///

const Messages = {
  ///
  /// left side bar toggle
  ///
  SERIES_SIDEBAR_VIEW_TOGGLE: "series_sidebar_view_toggle",

  ///
  /// for temp. toggle toolbar button
  ///
  TOGGLE_ACTIVE_TOOLBAR_BUTTON: "toggle_active_toolbar_button",
  SET_ACTIVE_TOOLBAR_BUTTON: "set_active_toolbar_button",
  ///
  /// 데이터 프로바이더 관련 메세지
  ///
  NEW_METADATA: "provider_new_image",
  /**
   * -- payload --
   * seriesID : Series 데이터를 구분하기 위한 ID
   * seriesNumber : Series number 태그
   * studyDescription : study description 태그
   * numOfFrame : Frame 갯수
   */

  INIT_VIEWPORT: "init_viewport",
  READY_ACTIVE_VIEWPORT: "ready_active_viewport",

  ///
  /// Toggle Dicom TAG
  ///
  TOGGLE_DICOM_TAG: "toggle_dicom_tag",

  ///
  /// SeriesList Section. 데이터 요청/전달 메세지
  ///
  /**
   * @description 특정 DCMView에 데이터 출력 요청
   * @param {string} seriesInsttanceUID
   * @param {string} modality
   */
  REQUEST_SEND_TO_VIEWPORT: "request_send_to_viewport",
  /**
   * @description 활성화된 DCMView에 데이터 출력 요청
   * @param {number} DCMViewIndex
   * @param {string} seriesInsttanceUID
   * @param {string} modality*
   */
  REQUEST_SEND_TO_ACTIVEVIEWPORT: "request_send_to_activeviewport",

  /**
   * @description
   */
  DELIVER_DATA_TO_VIEWPORT: "deliver_data_to_viewport",

  VIEWPORT_RENDER: "viewport_render",

  VIEW_ONE_VIEWPORT: "view_one_viewport",

  ///
  MEASURE_DROPDOWN_RENDER: "measure_dropdown_render",

  ///
  CONTRAST_DROPDOWN_RENDER: "contrast_dropdown_render",
  ///
  // Set Active tool
  SET_ACTIVE_TOOL: "set_active_tool",
  SET_ANNOTATION_ACTIVE_TOOL: "set_annotation_active_tool",

  SET_SCROLL_INDEX_ADD: "set_scroll_index_add",
  SET_VIEW_POSITION_INITIALIZE: "set_view_position_initialize",
  // contrast
  CONTRAST_VIEWPORT: "contrast_viewport",
  CONTRAST_DEFAULT: "contrast_default",
  CONTRAST_FULL_DYNAMIC: "contrast_full_dynamic",
  RENDER_INVERT: "render_invert",
  SET_CONTRAST_MODE_ON_ACTIVE: "set_contrast_mode_on_active",

  INIT_STUDY_MOUSE_STATE: "init_study_mouse_state",

  CONTINUE_READ_METADATA: "provider_continue_read_metadata",

  CHANGE_VIEWPORT_ARRAY: "change_viewport_array",

  SET_ACTIVE_SPECIFIC_SERIES: "set_active_specific_series",
  CHANGE_ACTIVE_STUDY: "change_active_study",
  REDRAW_DCMTAG: "redraw_dcmtag",
  ///
  /// Dialog 제어 메세지
  ///
  OPEN_MESSAGE_BOX: "open_message_box",
  OPEN_PREVIEW_DCM_DIALOG: "open_preview_dcm_dialog",
  //////////////////////////////////////////////////////

  /**
   * @description 특정 viewport 를 활성화 상태로 변경한다.
   */
  CHANGE_ACTIVE_VIEWPORT: "change_active_viewport",

  REMOVE_VIEWPORT: "remove_viewport", // remove a viewport
  CLEAR_VIEWPORT: "clear_viewport", // remove a viewport

  REMOVE_METADATA: "remove_metadata", // remove related dicom data
  CLEAR_ALL_METADATA: "clear_all_metadata", // remove all dicom data

  CACHE_MAXIMUM_SIZE_CHANGED: "provider_cache_maximum_size_changed",
  CACHE_PROMISE_REMOVED: "provider_cache_promise_removed",
  CACHE_FULL: "provider_cache_full",
  CACHE_CHANGED: "provider_cache_changed"
};

export default Messages;
